import { withInstall } from '@pit-element-plus/utils'
import DatePicker from './src/date-picker'

import type { SFCWithInstall } from '@pit-element-plus/utils'

export const ElDatePicker: SFCWithInstall<typeof DatePicker> =
  withInstall(DatePicker)

export default ElDatePicker
export * from './src/props'
export type { DatePickerInstance } from './src/instance'
